import React, { useState, Component } from 'react';
import { MailIcon, MapPinIcon, PhoneIcon, CheckCircleIcon, LoaderIcon } from 'lucide-react';
import { GoogleMapComponent } from './GoogleMapComponent';
export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    isSubmitting: false,
    isSubmitted: false,
    error: null
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    // Validate form
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Please fill out all fields'
      });
      return;
    }
    // Set loading state
    setFormStatus({
      isSubmitting: true,
      isSubmitted: false,
      error: null
    });
    try {
      // Simulate sending message to server
      await new Promise(resolve => setTimeout(resolve, 1500));
      // Set success state
      setFormStatus({
        isSubmitting: false,
        isSubmitted: true,
        error: null
      });
      // Reset form after success
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => {
        setFormStatus(prev => ({
          ...prev,
          isSubmitted: false
        }));
      }, 5000);
    } catch (error) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Failed to send message. Please try again.'
      });
    }
  };
  return <section id="contact" className="w-full bg-black text-white py-20" data-id="element-32">
      <div className="container mx-auto px-4" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-35">Get In Touch</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-36"></div>
          <p className="mt-6 text-gray-300 max-w-2xl mx-auto" data-id="element-37">
            Have questions about our platform? Ready to get started? Our team is
            here to help you.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-38">
          <div className="bg-gray-900 p-8 rounded-lg" data-id="element-39">
            <h3 className="text-2xl font-bold mb-6" data-id="element-40">Contact Information</h3>
            <div className="space-y-6" data-id="element-41">
              <div className="flex items-start" data-id="element-42">
                <MapPinIcon className="text-red-600 h-6 w-6 mr-3 mt-1" data-id="element-43" />
                <div data-id="element-44">
                  <h4 className="font-semibold" data-id="element-45">Address</h4>
                  <p className="text-gray-300" data-id="element-46">
                    296 Francis Baard Street Office 0314
                    <br data-id="element-47" />
                    Pretoria CBD
                    <br data-id="element-48" />
                    Gauteng
                    <br data-id="element-49" />
                    0002
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-50">
                <MailIcon className="text-red-600 h-6 w-6 mr-3 mt-1" data-id="element-51" />
                <div data-id="element-52">
                  <h4 className="font-semibold" data-id="element-53">Email</h4>
                  <p className="text-gray-300" data-id="element-54">am@binary-solutions.co.za</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-55">
                <PhoneIcon className="text-red-600 h-6 w-6 mr-3 mt-1" data-id="element-56" />
                <div data-id="element-57">
                  <h4 className="font-semibold" data-id="element-58">Phone</h4>
                  <p className="text-gray-300" data-id="element-59">+ 27 677 834 937</p>
                </div>
              </div>
            </div>
            {/* Google Map Component */}
            <div className="mt-6 h-[250px]" data-id="element-60">
              <GoogleMapComponent data-id="element-61" />
            </div>
            <div className="mt-8 pt-8 border-t border-gray-700" data-id="element-62">
              <h4 className="font-semibold mb-4" data-id="element-63">Follow Us</h4>
              <div className="flex space-x-4" data-id="element-64">
                <a href="https://x.com" className="w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 transition-colors" data-id="element-65">
                  <span className="sr-only" data-id="element-66">X</span>
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-67">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-68" />
                  </svg>
                </a>
                <a href="https://www.linkedin.com" className="w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 transition-colors" data-id="element-69">
                  <span className="sr-only" data-id="element-70">LinkedIn</span>
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-71">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-72" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="bg-gray-900 p-8 rounded-lg" data-id="element-73">
            <h3 className="text-2xl font-bold mb-6" data-id="element-74">Send Us a Message</h3>
            {formStatus.isSubmitted ? <div className="flex flex-col items-center justify-center h-64 text-center" data-id="element-75">
                <CheckCircleIcon className="h-16 w-16 text-red-500 mb-4" data-id="element-76" />
                <h4 className="text-xl font-semibold mb-2" data-id="element-77">Message Sent!</h4>
                <p className="text-gray-300" data-id="element-78">
                  Thank you for reaching out. We'll get back to you shortly.
                </p>
              </div> : <form className="space-y-4" onSubmit={handleSubmit} data-id="element-79">
                <div data-id="element-80">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-81">
                    Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Your name" required data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-84">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Your email" required data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-87">
                    Subject
                  </label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Subject" required data-id="element-88" />
                </div>
                <div data-id="element-89">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-90">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Your message" required data-id="element-91"></textarea>
                </div>
                {formStatus.error && <div className="text-red-500 text-sm" data-id="element-92">{formStatus.error}</div>}
                <button type="submit" disabled={formStatus.isSubmitting} className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-4 rounded-md transition-colors flex items-center justify-center disabled:bg-red-800 disabled:cursor-not-allowed" data-id="element-93">
                  {formStatus.isSubmitting ? <>
                      <LoaderIcon className="animate-spin -ml-1 mr-2 h-5 w-5" data-id="element-94" />
                      Sending...
                    </> : 'Send Message'}
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
};